import dayjs from 'dayjs'

// plugins
import advanced from 'dayjs/plugin/advancedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import minMax from 'dayjs/plugin/minMax'
import { loadDynamicScript } from '../loaders/loadDynamicScript'

dayjs.extend(advanced)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(localizedFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(minMax)

export async function setDayJsLocale(locale: string): Promise<void> {
  window.dayjs = dayjs

  loadDynamicScript(
    `day-js-locale-${locale}`,
    `https://cdn.jsdelivr.net/npm/dayjs@1/locale/${locale}.js`,
    () => {
      dayjs.locale(locale)
    },
  )
}
export default dayjs
